import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import completo from "../../Assets/Projects/ind_completos_stgo.jpg";
import mapapleto from "../../Assets/Projects/mapapleto.png";

function Genolab() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <div style={{ maxWidth: "600px", margin: "0 auto", textAlign: "center" }}>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 4rem)" }} className="project-heading">
            Ge<strong className="purple">No</strong>Lab
          </h1>
          <p style={{ color: "white" }}>
            Geospatial Nonsense Lab
            <br />
            <em>"Rigorous data, ridiculous questions."</em>
            <br />
            <br />
            GeNoLab es un espacio que estoy construyendo para aplicar
            <b className="purple"> análisis espacial complejo a preguntas absurdas</b>.
            Aquí encontrarás experimentos que a nadie le interesa, pero que igual hice.
          </p>
        </div>

<Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
  <Col md={4} className="project-card">
    <ProjectCard
      imgPath={mapapleto}
      isBlog={false}
      title="MapaPleto"
      description="Proyecto piloto de cartografía interactiva que analiza la distribución espacial de la oferta gastronómica (locales de completos) y suministros (supermercados) en Chile."
      ghLink=""
      demoLink="https://mapapleto.vercel.app/"
      newsLinks={[
        {
          text: "Sabes.cl",
          url: "https://sabes.cl/2026/05/24/geografo-chileno-crea-mapapleto-sitio-para-encontrar-locales-de-completos-de-todo-chile/"
        },
        {
          text: "Winforma",
          url: "https://www.instagram.com/p/DYvKILam5c7/?utm_source=ig_web_button_share_sheet"
        }
      ]}
    />
  </Col>

  <Col md={4} className="project-card">
    <ProjectCard
      imgPath={completo}
      isBlog={false}
      title="La Ciudad del Completo"
      description="Indicador Espacial de Accesibilidad a Completos (hot dogs chilenos)"
      ghLink=""
      demoLink="https://www.linkedin.com/posts/jorge-aravena-pe%C3%B1a-248780162_diadelcompleto-analisisespacial-urbano-activity-7332044300169461761-fCLB?utm_source=share&utm_medium=member_desktop&rcm=ACoAACbpvVgBGquo1NGfE8Lk5CGO7psojcTHQX8"
    />
  </Col>
</Row>
      </Container>
    </Container>
  );
}

export default Genolab;
